import { useEffect, useState } from "react";
import clsx from "clsx";
import { PlaidLink } from "react-plaid-link";
import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";

import styles from "./style.module.scss";
import { getLinkToken } from "../../services/api/userSetting";
import { RefLoadingSpinner } from "../LoadingSpinner";

interface IProps {
  label: string;
  className?: string;
  btnClass?: string;
  loading?: boolean;
  onPlaidSuccess: (token: string, accountIds: string[]) => void;
  onPlaidFailed?: VoidFunction;
}

type LinkToken = {
  link_token: string;
};

export default function PlaidLinkComponent({
  label,
  className,
  btnClass,
  loading = false,
  onPlaidSuccess,
  onPlaidFailed
}: Readonly<IProps>) {
  const handleOnSuccess = (token: string, metadata: any) => {
    onPlaidSuccess(token, metadata.accounts);
  };

  const [linkToken, setLinkToken] = useState<string>("");
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchLinkToken = async () => {
      try {
        setIsFetching(true);
        const { link_token } = await getLinkToken<LinkToken>();
        setLinkToken(link_token);
      } catch (err) {
        // console.error("Error fetching link token:", err);
      } finally {
        setIsFetching(false);
      }
    };
    !linkToken && fetchLinkToken();
  }, [setLinkToken, linkToken]);

  if (isFetching && !linkToken) {
    return <RefLoadingSpinner isLoadingMore={isFetching} observerRef={null} />;
  }

  if (loading) {
    return (
      <div className={clsx(styles.plaidLinkContainer, className)}>
        <button
          type="button"
          disabled
          className={clsx(
            "!bg-muted !text-white !border-none !px-10 !w-full !rounded-full desktop:!w-fit desktop:!rounded-base desktop:!mx-auto flex items-center justify-center gap-2 opacity-70 cursor-not-allowed",
            btnClass
          )}>
          <Icon path={mdiLoading} size={1} spin={1} />
          <span>Linking...</span>
        </button>
      </div>
    );
  }

  return (
    <div className={clsx(styles.plaidLinkContainer, className)}>
      {Boolean(linkToken) && (
        <PlaidLink
          onSuccess={handleOnSuccess}
          onExit={onPlaidFailed}
          token={linkToken}
          env={process.env.REACT_APP_PLAID_ENV}
          clientName="HaulPay"
          className={clsx(
            "!bg-muted !text-white !border-none !px-10 !w-full !rounded-full desktop:!w-fit desktop:!rounded-base desktop:!mx-auto",
            btnClass
          )}>
          {label}
        </PlaidLink>
      )}
    </div>
  );
}
